import { render, staticRenderFns } from "./DiseasePreview.vue?vue&type=template&id=04a8384a"
import script from "./DiseasePreview.vue?vue&type=script&lang=js"
export * from "./DiseasePreview.vue?vue&type=script&lang=js"
import style0 from "./DiseasePreview.vue?vue&type=style&index=0&id=04a8384a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports